import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import pick from 'lodash/pick';
import noop from 'lodash/noop';
import { fetchProfile, onAuthStateChanged } from '../lib/firebase';
import { getUserId, setProfile, setUid } from '../store/ducks/profile';
import { setDownloadLink } from '../store/ducks/branch';
import { createDownloadLink } from '../lib/branch';

function AuthSetup({
  saveDownloadLink,
  storedUid,
  storeProfile,
  storeUid,
}) {
  useEffect(
    () => onAuthStateChanged((user) => {
      const currentUid = user && user.uid;
      if (currentUid === storedUid) return;

      if (currentUid) {
        storeUid(user.uid);
        fetchProfile(user.uid).then((userSnap) => {
          const profile = userSnap.data();
          storeProfile(profile);
          createDownloadLink(pick(profile, 'phoneNumber'))
            .then(link => saveDownloadLink(link))
            .catch(noop);
        });
      } else {
        storeProfile(null);
        storeUid(null);
      }
    }),
    [saveDownloadLink, storeProfile, storeUid, storedUid],
  );

  return null;
}

AuthSetup.propTypes = {
  saveDownloadLink: PropTypes.func.isRequired,
  storedUid: PropTypes.string,
  storeProfile: PropTypes.func.isRequired,
  storeUid: PropTypes.func.isRequired,
};

AuthSetup.defaultProps = {
  storedUid: undefined,
};

function mapStateToProps(state) {
  return {
    storedUid: getUserId(state),
  };
}

const mapDispatchToProps = {
  storeProfile: setProfile,
  storeUid: setUid,
  saveDownloadLink: setDownloadLink,
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthSetup);
